import { createSlice } from '@reduxjs/toolkit';

import awardsDataRaw from 'data/awards.json';

import { AwardsState, Award, AwardsYear } from 'interfaces';

const initialStateDefault: AwardsState = {
  awards: {}
};

const awardsData: Award[] = awardsDataRaw as unknown as Award[];

const awardsSlice = createSlice({
  name: 'awards',
  initialState: initialStateDefault,
  reducers: {
    getAwards (state) {
      const newAwards: AwardsYear = awardsData.reduce((acc: AwardsYear, current: Award, index: number, arr: Award[]) => {
        const hasYear = (acc?.[current.year]?.length || 0) > 0;
        return { ...acc, [current.year]: hasYear ? [ ...acc?.[current.year], current ] : [ current ] };
      }, {});

      return {
        ...state,
        awards: newAwards
      };
    }
  }
});

export const { getAwards } = awardsSlice.actions;

export default awardsSlice.reducer;
